export default function (...parts: (string | number)[]) {
  return parts.filter(p => typeof p === 'string' || typeof p === 'number').join('')
}
